__webpack_require__.p = "/year-end-sharing-nuts-2025/";